<div
  class="flex flex-col h-[calc(100vh-9rem)] gap-lg mt-lg"
  data-testid="department-quick-view">
  @let detailsState = details();

  <lib-section-header
    [title]="'department_quick_view_info_section' | transloco"
    [contentTemplate]="infoSection">
    <ng-template #infoSection>
      @switch (detailsState.status) {
        @case ('loading') {
          <lib-loader />
        }
        @case ('error') {
          <ng-container
            *ngTemplateOutlet="
              sectionError;
              context: { $implicit: 'info', testId: 'quick-view-info-error' }
            " />
        }
        @default {
          <dl class="grid grid-cols-2 gap-lg">
            <div>
              <dt class="text-xs2 font-medium text-neutral-500">
                {{ 'department_quick_view_legal_entity_label' | transloco }}
              </dt>
              <dd
                class="text-xs font-semibold text-neutral-900"
                data-testid="quick-view-legal-entity">
                {{
                  info().legalEntity || ('details_not_found_label' | transloco)
                }}
              </dd>
            </div>
            <div>
              <dt class="text-xs2 font-medium text-neutral-500">
                {{ 'department_quick_view_parent_label' | transloco }}
              </dt>
              <dd
                class="text-xs font-semibold text-neutral-900"
                data-testid="quick-view-parent">
                @if (info().parent; as parent) {
                  <span class="inline-flex items-center gap-sm">
                    @if (parent.imageUrl) {
                      <img
                        [src]="parent.imageUrl"
                        [alt]="parent.name"
                        width="24"
                        height="24"
                        class="size-6 rounded-full object-cover"
                        data-testid="quick-view-parent-avatar" />
                    } @else {
                      <span
                        class="size-6 rounded-full bg-primary-50 text-primary-500 text-xs2 flex items-center justify-center"
                        data-testid="quick-view-parent-avatar">
                        {{ parent.name | avatar }}
                      </span>
                    }
                    @if (parent.detailsPath) {
                      <a
                        class="underline"
                        [routerLink]="[
                          parent.detailsPath | tenantPath: 'admin',
                        ]">
                        {{ parent.name }}
                      </a>
                    } @else {
                      <span class="underline">{{ parent.name }}</span>
                    }
                  </span>
                } @else {
                  {{ 'details_not_found_label' | transloco }}
                }
              </dd>
            </div>
            <div>
              <dt class="text-xs2 font-medium text-neutral-500">
                {{ 'department_quick_view_manager_label' | transloco }}
              </dt>
              <dd
                class="text-xs font-semibold text-neutral-900"
                data-testid="quick-view-manager">
                @if (info().manager; as manager) {
                  <span class="inline-flex items-center gap-sm">
                    @if (manager.imageUrl) {
                      <img
                        [src]="manager.imageUrl"
                        [alt]="manager.name"
                        width="24"
                        height="24"
                        class="size-6 rounded-full object-cover"
                        data-testid="quick-view-manager-avatar" />
                    } @else {
                      <span
                        class="size-6 rounded-full bg-primary-50 text-primary-500 text-xs2 flex items-center justify-center"
                        data-testid="quick-view-manager-avatar">
                        {{ manager.name | avatar }}
                      </span>
                    }
                    <span>{{ manager.name }}</span>
                  </span>
                } @else {
                  {{ 'details_not_found_label' | transloco }}
                }
              </dd>
            </div>
            <div>
              <dt class="text-xs2 font-medium text-neutral-500">
                {{ 'department_quick_view_type_label' | transloco }}
              </dt>
              <dd
                class="text-xs font-semibold text-neutral-900"
                data-testid="quick-view-type">
                {{ info().type || ('details_not_found_label' | transloco) }}
              </dd>
            </div>
          </dl>
        }
      }
    </ng-template>
  </lib-section-header>

  <lib-section-header
    [title]="'department_quick_view_users_section' | transloco"
    [contentTemplate]="usersSection">
    <ng-template #usersSection>
      @switch (usersPreview().status) {
        @case ('loading') {
          <lib-loader />
        }
        @case ('error') {
          <ng-container
            *ngTemplateOutlet="
              sectionError;
              context: {
                $implicit: 'users',
                testId: 'quick-view-users-error',
              }
            " />
        }
        @default {
          @if (!previewUsers().length) {
            <p class="text-sm text-neutral-500">
              {{ 'department_quick_view_no_users' | transloco }}
            </p>
          } @else {
            <p class="text-xs2 font-medium text-neutral-500 mb-x-sm">
              {{ 'department_quick_view_users_section' | transloco }}
            </p>
            @for (departmentKey of departmentKeys(); track departmentKey) {
              <lib-user-dropdown-view
                data-testid="quick-view-users"
                [userTableList]="previewUsers()"
                [userCount]="usersPreview().data.total"
                [userDropdownList]="dropdownViewUsers()"
                [totalDropdownCount]="dropdownTotal()"
                [currentDropdownPage]="dropdownPage()"
                [totalDropdownPages]="dropdownLastPage()"
                [isDropdownLoading]="usersListStatus() === 'loading'"
                [croppedNumber]="previewUserLimit"
                [showIndividualAvatar]="false"
                [containerRef]="'department-quick-view'"
                [toggleContainerClass]="'justify-start w-auto'"
                [imgDimensions]="{ width: 2, height: 2 }"
                [searchLabel]="
                  'department_quick_view_users_section' | transloco
                "
                [searchPlaceholder]="'search_by_name_placeholder' | transloco"
                [headerListLabel]="
                  'department_quick_view_users_section' | transloco
                "
                [noSearchResultLabel]="'no_search_result_label' | transloco"
                (handleMenuToggle)="loadUsersMenu($event)">
                @if (usersListStatus() === 'error') {
                  <div additional-menu-overlay-actions class="w-full">
                    <ng-container
                      *ngTemplateOutlet="
                        sectionError;
                        context: {
                          $implicit: 'usersList',
                          testId: 'quick-view-users-list-error',
                        }
                      " />
                  </div>
                }
              </lib-user-dropdown-view>
            }
          }
        }
      }
    </ng-template>
  </lib-section-header>

  <lib-section-header
    [title]="'department_quick_view_positions_section' | transloco"
    [contentTemplate]="positionsSection">
    <ng-template #positionsSection>
      <div class="flex flex-col gap-md">
        @switch (positions().status) {
          @case ('loading') {
            <lib-loader />
          }
          @case ('error') {
            <ng-container
              *ngTemplateOutlet="
                sectionError;
                context: {
                  $implicit: 'positions',
                  testId: 'quick-view-positions-error',
                }
              " />
          }
          @default {
            <div class="grid grid-cols-2 gap-md">
              @for (position of positions().data; track position.id) {
                <lib-department-position-card [position]="position" />
              } @empty {
                <p class="col-span-2 text-sm text-neutral-500">
                  {{ 'department_quick_view_no_positions' | transloco }}
                </p>
              }
            </div>
          }
        }
        <a
          class="text-sm font-medium text-primary-500"
          data-testid="quick-view-see-all-positions"
          fragment="positions"
          [routerLink]="[detailsPath() | tenantPath: 'admin']">
          + {{ 'department_quick_view_see_all_positions' | transloco }}
        </a>
      </div>
    </ng-template>
  </lib-section-header>

  <div
    class="mt-auto flex justify-end gap-md pt-lg border-t border-neutral-200">
    <a
      class="py-sm px-2xl rounded-md bg-primary-50 text-primary-500 font-medium text-sm"
      data-testid="quick-view-edit"
      [routerLink]="[editPath() | tenantPath: 'admin']">
      {{ 'department_quick_view_edit_button' | transloco }}
    </a>
    <a
      class="py-sm px-2xl rounded-md bg-primary-500 text-white font-medium text-sm"
      data-testid="quick-view-full-details"
      [routerLink]="[detailsPath() | tenantPath: 'admin']">
      {{ 'department_quick_view_full_details_button' | transloco }}
    </a>
  </div>
</div>

<ng-template #sectionError let-section let-testId="testId">
  <div
    class="flex items-center justify-between gap-md text-sm text-destructive-700"
    role="alert"
    [attr.data-testid]="testId">
    <span>{{ 'department_quick_view_section_error' | transloco }}</span>
    <button
      type="button"
      class="font-medium underline cursor-pointer"
      (click)="retry(section)">
      {{ 'department_retry_button' | transloco }}
    </button>
  </div>
</ng-template>
